"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutdatedBrowserInfo = void 0;
var _config = require("@ori-appshell/config");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const name = 'outdated-browser-info';
const OutdatedBrowserInfo = ({
  environment,
  language,
  servicesUrls,
  tenant
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: `${name}-root`,
    "data-app-url": `${servicesUrls?.clientApps.baseUrl}/${name}/`,
    "data-config": (0, _react.useMemo)(() => JSON.stringify({
      currentLanguage: language,
      staticApiUrl: servicesUrls?.staticApi.baseUrl,
      tenant
    }), [language, servicesUrls?.staticApi.baseUrl, tenant])
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
    defer: true,
    crossOrigin: "anonymous",
    id: `${name}-script`,
    src: (0, _config.createSpaEntryfileUrl)(name, environment, servicesUrls?.clientApps.baseUrl)
  })]
});
exports.OutdatedBrowserInfo = OutdatedBrowserInfo;
